var blockquote_default = {
  "fontElementMap": "FnUew",
  "quote": "_50Xdi"
};
export {
  blockquote_default as default
};
//# sourceMappingURL=blockquote-scss.js.map
